import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TopPerformingGroupsComponent } from './top-performing-groups.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { FormatNumberPipeModule, RoundNumberPipeModule } from '@sociuu/shared';

@NgModule({
  declarations: [TopPerformingGroupsComponent],
  exports: [TopPerformingGroupsComponent],
  imports: [
    CommonModule,
    MatDividerModule,
    MatCardModule,
    FormatNumberPipeModule,
    RoundNumberPipeModule,
  ],
})
export class TopPerformingGroupsModule {}
